import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadConsent, loadGoogleAnalytics, disableGoogleAnalytics, trackPageView } from '@/lib/analytics';

/** Applies saved consent on mount, listens for changes, and tracks SPA page views. */
export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const consent = loadConsent();
    if (consent?.analytics) loadGoogleAnalytics();
    else disableGoogleAnalytics();

    const onChange = (e: Event) => {
      const detail = (e as CustomEvent).detail as { analytics?: boolean } | undefined;
      if (detail?.analytics) loadGoogleAnalytics();
      else disableGoogleAnalytics();
    };
    window.addEventListener('aimup-cookie-consent-changed', onChange as EventListener);
    return () => window.removeEventListener('aimup-cookie-consent-changed', onChange as EventListener);
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};
